/**
 * Alphabetical order sorting (ascending)
 *
 * @param {*[]} arr array of things to compare
 * @param {(any) => string} selector select the field to compare (default el => el)
 * @returns {*[]} sorted array
 */
export const alphabeticalOrder = (arr, selector = (el) => el) => {
  return arr.sort((a, b) => {
    if (selector(a)?.toLowerCase() < selector(b)?.toLowerCase()) {
      return -1;
    } else {
      return 1;
    }
  });
};

export const removeObjectsDuplicatesFromArray = (arr) => {
  const uniqueObjects = {};
  const uniqueArray = [];

  arr.forEach((obj) => {
    const objStr = JSON.stringify(obj.id);

    if (!uniqueObjects[objStr]) {
      uniqueObjects[objStr] = true;
      uniqueArray.push(obj);
    }
  });

  return uniqueArray;
};
